import { render } from "./PhotoDescription.vue?vue&type=template&id=e005c0ea&scoped=true"
import script from "./PhotoDescription.vue?vue&type=script&lang=ts"
export * from "./PhotoDescription.vue?vue&type=script&lang=ts"

import "./PhotoDescription.vue?vue&type=style&index=0&id=e005c0ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e005c0ea"

export default script